export default __webpack_public_path__ + "static/media/s-training.51e01909.jpg";